export default "__VITE_ASSET__CbhKlr_a__"